export interface RuntimeConfig {
  API_BASE_URL: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const runtime = window.__APP_CONFIG__ ?? {};

/**
 * La config runtime (`/config.js`, régénérée au démarrage du conteneur) passe
 * AVANT la variable de build : c'est elle qui permet de promouvoir la même
 * image de staging vers la prod sans reconstruire.
 */
export const config: RuntimeConfig = {
  API_BASE_URL: runtime.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '/api',
};
